import type React from 'react';

import { Loader } from '@change-corgi/design-system-legacy/components/progressiveDisclosure';

export const LoadingState: React.FC = () => {
	return <Loader size="m" mx="auto" my={24} />;
};
